module.exports = __webpack_public_path__ + "img/PS12.6a8670ef.png";